import Vue from 'vue'

/**
 * A component that uses this mixin to be a tile in a masonry layout needs to do the following:
 * 1) When the component is loaded and height can be determined, set "this.isReady" to true
 * 2) When the tileWidth changes, "this.isReady" will be set back to false and needs to be set
 *    back to true when the tile is ready to be re-positioned.  In most cases this can be right
 *    away.  This can be accomplished by putting a "watch" on "tileWidth" and setting isReady
 *    at that time.  An exception is vc-pinboard where images need to calculate new heights and
 *    may take some time.
 * 3) If a single tile changes it's height, call this.tileExpanded(). This handles the case that
 *    exists on comments pinboard of chatter where a "read more" is clicked, causing the tile to
 *    grow in height.
 * 4) Inline styles will be applied to the component's root element to size and position it.
 *    If there are no other inline styles to be applied by the component itself, just put
 *      :style="tileStyles"
 *    on the root element of the component.  If there are other styles to add, use this.tileStyles()
 *    to get the styles needed for the layout and add whatever other styles are needed.
 * 5) The order of the tile (tileOrder) needs to be set as a prop when the component is used inside
 *    the layout. An example using the Comment component:
 *      <tt-comment v-for="(comment, index) in comments"
 *                  :tileOrder="index"
 *                  :key="comment.id">
 */
export default Vue.extend({
  data() {
    return {
      // signifies if the tile is ready to be drawn or redrawn
      isReady: false,
      tileAttributes: {
        width: 0,
        opacity: 0,
        top: 0,
        left: 0
      }
    }
  },
  props: {
    tileOrder: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isTile() {
      return this.tileWidth > 0
    },
    tileStyles() {
      if (!this.isTile) {
        return {}
      }
      const styleProps = this.tileAttributes
      return {
        width: this.tileWidth > 0 ? `${this.tileWidth}px` : 0,
        opacity: styleProps.opacity,
        transform: `translateX(${styleProps.left}px) translateY(${styleProps.top}px)`
      }
    },
    tileWidth() {
      return this.tileAttributes.width
    }
  },
  methods: {
    // called by layout.ts when the tileWidth has changed
    setWidth(width) {
      // setting "isReady" back to false so the tile can determine when it is ready to be
      // repositioned.
      this.isReady = false
      this.tileAttributes.width = width
    },
    tileHeightChanged() {
      // the slot (child) component changed height.
      // from here, fire event up to the layout to handle the height change
      this.$parent.$emit('tileHeightChanged', this)
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/layouts/masonry/tile-mixin.ts